// extracted by mini-css-extract-plugin
export default {"icon":"Service_icon__FGK1M","title":"Service_title__3-XRt","details":"Service_details__DPmYM"};